
export default {
  name: "ResetPasswordSuccess"
};
